import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Paths from "../../../constants/paths";
import ChevronIcon from "../../../assets/icons/chevron.svg?react";

export const CollectionParametersHeader = () => {
  const { t } = useTranslation("boLogistics");
  const navigate = useNavigate();

  return (
    <div className="flex w-full flex-col justify-between gap-2">
      <div className="flex flex-row items-center gap-2">
        <button
          onClick={() => navigate(Paths.bo.collection)}
          className="text-sm font-medium text-gray-600 hover:text-gray-900"
        >
          {t("collectionParametersPage.breadcrumbCollection")}
        </button>
        <ChevronIcon width={10} height={10} />
        <span className="text-brand700 text-sm font-medium">
          {t("collectionParametersPage.breadcrumbCurrent")}
        </span>
      </div>
      <div className="flex w-full flex-col gap-3">
        <h1 className="font-jakarta-sans text-3xl font-semibold">
          {t("collectionParametersPage.title")}
        </h1>
        <p>{t("collectionParametersPage.subtitle")}</p>
      </div>
    </div>
  );
};
